<template>
	<div class="header">
		<!-- 长沙师范学院 navbar3 -->
		<img src="@/assets/navbar3.png" alt="" class="logoPic">
		<!-- <div class="title">{{!userInfo?'':'新媒体电商一体化实训平台'}}</div> -->
		<div class="title">{{!userInfo?'':'Live streaming training platform'}}</div>
		<div class="rightMainBox">
      <div class="infoN">
        <img @click="showInfF" :src="userInfo.avatar?userInfo.avatar:require('@/assets/navbar_2.png')" alt="" class="avatar">
        <div @click="showInfF" class="userNameBox">{{userInfo.realName?userInfo.realName:userInfo.username}}</div>
        <div class="infoM" style="display: none">
          <ul>
            <li @click="changeinfo">修改密码</li>
            <li @click="logOut">退出登录</li>
          </ul>
        </div>
      </div>

			<!-- <img src="@/assets/navbar_3.png" alt="" class="line">
			<div class="btnBox1" @click.stop="minimizeWin">
				<img src="@/assets/navbar_4.png" alt="" class="toSmall">
			</div>
			<div class="btnBox2" @click.stop="maximizeWin">
				<img src="@/assets/navbar_5.png" alt="" class="toBig">
			</div>
			<div class="btnBox3" @click.stop="closeWin">
				<img src="@/assets/navbar_6.png" alt="" class="toClose">
			</div> -->
		</div>
		<!-- <span @click.stop="easyGan">金手指</span> -->
	</div>
</template>
<script>
	//import { remote } from 'electron';
	import emitFn from './index'
  import {logoutApi} from '@/api/user'
	export default {
		data() {
			return {
				userInfo:'',
        showInf:false,
			}
		},
		computed:{
			userInfo1(){
				return this.$store.state.user.userInfo
			}
		},
		watch:{
			userInfo1(){
				this.userInfo = this.$store.state.user.userInfo
			}
		},
		created() {
			this.userInfo = (window.localStorage.getItem('userInfo'))?(JSON.parse(window.localStorage.getItem('userInfo'))):''
		},
		methods: {
      showInfF(){
        console.log('0000000')
        this.showInf = !this.showInf
      },
      changeinfo(){
        this.$router.push({
          path:'/userCenter/userCenterUpdate',

        })
      },
      logOut(){
        logoutApi().then(res=>{
          window.localStorage.clear()
          location.reload()
        })
      },
			// minimizeWin() {
			// 	remote.getCurrentWindow().minimize(); // 窗口最小化
			// },
			// maximizeWin() {
			// 	const win = remote.getCurrentWindow();
			// 	if (win.isMaximized()) { // 判断 窗口是否已最大化
			// 		win.restore(); // 恢复原窗口大小
			// 	} else {
			// 		win.maximize(); //最大化窗口
			// 	}
			// },
			// closeWin() {
			// 	remote.getCurrentWindow().close(); // 关闭窗口，也结束了所有进程
			// },
			easyGan() {
				const that = this
				emitFn.$emit("easyGan", 1);
			},
		}
	}
</script>
<style lang="scss">
  .infoN:hover .infoM {
    display: block!important;
  }
  .userNameBox:hover .infoM {
    display: block!important;
  }
  .avatar:hover .infoM {
    display: block!important;
  }
	.header {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 1rem;
		z-index: 99999;
		// background-color: rgba(119, 118, 253, 1);
		background-image: url(../assets/navbar_0.png);
		background-size: 100% 100%;
		background-repeat: no-repeat;
		-webkit-app-region: drag;
		box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.1);
		display: flex;
		align-items: center;
		justify-content: flex-start;
		flex-direction: row;
		box-sizing: border-box;
		padding: 0 0.33rem 0 0.23rem;
		// 必须设置在按钮区以外
		// -webkit-user-select: none;

		span {
			font-size: 20px;
			margin-right: 10px;
			color: red;
			line-height: 1rem;

		}

		.logoPic {
			width: 2rem;
			height: auto;
			// width: 0.5rem;
			// height: 0.5rem;
			margin-right: 0.21rem;
			padding-left: 0.2rem;
		}
		.title {
			font-size: 0.26rem;
			font-family: Source Han Sans CN;
			font-weight: bold;
			color: #FFFFFF;
		}
		.rightMainBox {
			display: flex;
			align-items: center;
			justify-content: flex-start;
			flex-direction: row;
			height: 1rem;
			//overflow: hidden;
			margin-left: auto;
      .infoN {
        position: relative;
        cursor: pointer;
        -webkit-app-region: no-drag;
        z-index: 100000;
        height: 1rem;
        line-height: 0.35rem;
        text-align: center;
		display: flex;
		align-items: center;
        .avatar {
          width: 0.54rem;
          height: 0.54rem;
          border-radius: 50%;
        }
        .userNameBox {
          font-size: 0.22rem;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #FFFFFF;
          margin: 0 0.39rem 0 0.19rem;
        }
        .infoM {
          width: 1rem;
          background: rgb(128, 106, 251);
          position: absolute;
          bottom: -0.9rem;
          left: 0;
          ul {
            list-style: none;
            width: 100%;
            padding: 10px 0;
            box-sizing: border-box;
            border-radius: 5px;
            height: 1rem;
            li {
              list-style: none;
              line-height: 0.4rem;
              text-align: center;
              font-size: 0.15rem;
              color: #FFFFFF;
              cursor: pointer;
              &:hover {
                background: rgba(255,255,255,.3);
              }
            }

          }
        }
      }

			.line {
				height: 0.21rem;
				width: 0.02rem;
				margin-right: 0.36rem;
			}
			.btnBox1 {
				width: 0.25rem;
				height: 0.25rem;
				margin-right: 0.25rem;
				cursor: pointer;
				-webkit-app-region: no-drag;
				display: flex;
				align-items: center;
				justify-content: flex-start;
				flex-direction: row;
				.toSmall {
					width: 0.21rem;
					height: 0.02rem;
				}
			}
			.btnBox2 {
				width: 0.25rem;
				height: 0.25rem;
				margin-right: 0.3rem;
				cursor: pointer;
				-webkit-app-region: no-drag;
				display: flex;
				align-items: center;
				justify-content: flex-start;
				flex-direction: row;
				.toBig {
					width: 0.25rem;
					height: 0.2rem;
				}
			}
			.btnBox3 {
				width: 0.25rem;
				height: 0.25rem;
				cursor: pointer;
				-webkit-app-region: no-drag;
				display: flex;
				align-items: center;
				justify-content: flex-start;
				flex-direction: row;
				.toClose {
					width: 0.19rem;
					height: 0.19rem;
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/navbar.vue